module.exports = __webpack_public_path__ + "static/media/kneenetic-3.e0fe43f0.jpg";